<template>
  <div>
    <template v-if="ssrView">
      <div class="calculo-ssr-config-page">
        <div class="preparing">
          <div class="outer">
            <div class="inner">
              <template v-if="spinner.length > 0">
                <component :is="spinner" />
              </template>
              <template v-else>
                <div class="loading-spinner">
                  <div class="sk-circle1 sk-circle" />
                  <div class="sk-circle2 sk-circle" />
                  <div class="sk-circle3 sk-circle" />
                  <div class="sk-circle4 sk-circle" />
                  <div class="sk-circle5 sk-circle" />
                  <div class="sk-circle6 sk-circle" />
                  <div class="sk-circle7 sk-circle" />
                  <div class="sk-circle8 sk-circle" />
                  <div class="sk-circle9 sk-circle" />
                  <div class="sk-circle10 sk-circle" />
                  <div class="sk-circle11 sk-circle" />
                  <div class="sk-circle12 sk-circle" />
                </div>
              </template>
              <slot name="loader-message">
                <div class="title">
                  <h3>{{ (title.length > 0) ? title : 'Loading...' }}</h3>
                  <p v-if="description">{{ description }}</p>
                </div>
              </slot>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <component :is="view" />
    </template>
  </div>
</template>

<script>
export default {
  name: 'ssr-blocked-page',
  props: {
    title: {
      type: String,
      required: false,
      default: function() { return '' }
    },
    description: {
      type: String,
      required: false,
      default: function() { return '' }
    },
    spinner: {
      type: String,
      required: false,
      default: function() { return '' }
    }
  },
  computed: {
    ssrView: function() {
      return this.$route.meta.noSSR.active === true
    },
    view: function() {
      return this.$route.meta.noSSR.component
    }
  }
}
</script>

<style lang="scss" scoped>
  .calculo-ssr-config-page {
    min-height: 70vh;
  }

  .no-ssr-loader-wrapper {
    margin: 50px 20px;
  }

  .preparing .outer {
    position: relative;
    z-index: 15;
    margin: 0 auto;
    max-width:80%;
  }
  .preparing .inner {
    position: absolute;
    background-color: #fff;
    top: 0;
    padding: 2em;
    z-index: 20;
    text-align: center;
    width: 80%;
    border-radius: 3px;
    margin: 2em auto;
    left: 0;
    right: 0;
  }

  .preparing .overlay {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: .4;
    z-index: 10;
    background-color: #EEE;
  }

  .preparing .loading-spinner {
    margin: 2em auto;
    width: 4em;
    height: 4em;
    position: relative;
  }

  .preparing .loading-spinner .sk-circle {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }
  .preparing .title {

  }

  .preparing .loading-spinner .sk-circle:before {
    content: '';
    display: block;
    margin: 0 auto;
    width: 15%;
    height: 15%;
    background-color: #333;
    border-radius: 100%;
    -webkit-animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
            animation: sk-circleFadeDelay 1.2s infinite ease-in-out both;
  }
  .preparing .loading-spinner .sk-circle2 {
    -webkit-transform: rotate(30deg);
        -ms-transform: rotate(30deg);
            transform: rotate(30deg);
  }
  .preparing .loading-spinner .sk-circle3 {
    -webkit-transform: rotate(60deg);
        -ms-transform: rotate(60deg);
            transform: rotate(60deg);
  }
  .preparing .loading-spinner .sk-circle4 {
    -webkit-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
            transform: rotate(90deg);
  }
  .preparing .loading-spinner .sk-circle5 {
    -webkit-transform: rotate(120deg);
        -ms-transform: rotate(120deg);
            transform: rotate(120deg);
  }
  .preparing .loading-spinner .sk-circle6 {
    -webkit-transform: rotate(150deg);
        -ms-transform: rotate(150deg);
            transform: rotate(150deg);
  }
  .preparing .loading-spinner .sk-circle7 {
    -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
            transform: rotate(180deg);
  }
  .preparing .loading-spinner .sk-circle8 {
    -webkit-transform: rotate(210deg);
        -ms-transform: rotate(210deg);
            transform: rotate(210deg);
  }
  .preparing .loading-spinner .sk-circle9 {
    -webkit-transform: rotate(240deg);
        -ms-transform: rotate(240deg);
            transform: rotate(240deg);
  }
  .preparing .loading-spinner .sk-circle10 {
    -webkit-transform: rotate(270deg);
        -ms-transform: rotate(270deg);
            transform: rotate(270deg);
  }
  .preparing .loading-spinner .sk-circle11 {
    -webkit-transform: rotate(300deg);
        -ms-transform: rotate(300deg);
            transform: rotate(300deg);
  }
  .preparing .loading-spinner .sk-circle12 {
    -webkit-transform: rotate(330deg);
        -ms-transform: rotate(330deg);
            transform: rotate(330deg);
  }
  .preparing .loading-spinner .sk-circle2:before {
    -webkit-animation-delay: -1.1s;
            animation-delay: -1.1s;
  }
  .preparing .loading-spinner .sk-circle3:before {
    -webkit-animation-delay: -1s;
            animation-delay: -1s;
  }
  .preparing .loading-spinner .sk-circle4:before {
    -webkit-animation-delay: -0.9s;
            animation-delay: -0.9s;
  }
  .preparing .loading-spinner .sk-circle5:before {
    -webkit-animation-delay: -0.8s;
            animation-delay: -0.8s;
  }
  .preparing .loading-spinner .sk-circle6:before {
    -webkit-animation-delay: -0.7s;
            animation-delay: -0.7s;
  }
  .preparing .loading-spinner .sk-circle7:before {
    -webkit-animation-delay: -0.6s;
            animation-delay: -0.6s;
  }
  .preparing .loading-spinner .sk-circle8:before {
    -webkit-animation-delay: -0.5s;
            animation-delay: -0.5s;
  }
  .preparing .loading-spinner .sk-circle9:before {
    -webkit-animation-delay: -0.4s;
            animation-delay: -0.4s;
  }
  .preparing .loading-spinner .sk-circle10:before {
    -webkit-animation-delay: -0.3s;
            animation-delay: -0.3s;
  }
  .preparing .loading-spinner .sk-circle11:before {
    -webkit-animation-delay: -0.2s;
            animation-delay: -0.2s;
  }
  .preparing .loading-spinner .sk-circle12:before {
    -webkit-animation-delay: -0.1s;
            animation-delay: -0.1s;
  }

  @-webkit-keyframes sk-circleFadeDelay {
    0%, 39%, 100% { opacity: 0; }
    40% { opacity: 1; }
  }

  @keyframes sk-circleFadeDelay {
    0%, 39%, 100% { opacity: 0; }
    40% { opacity: 1; }
  }
</style>
